import { Component, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter, map, mergeMap } from 'rxjs';
import { Utilityservice } from '../utility/utilityservice.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css']
})
export class MainLayoutComponent {
  routernames: MenuItem[] = [];
  home: MenuItem;

  constructor(private router: Router,private activateroute:ActivatedRoute,private titleService: Title,
    private utitlityservice:Utilityservice
  ) {
    this.utitlityservice.fetchAndStoreConfigParams()
    this.updatePageTitle();
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {        
        this.updateBreadcrumbs(event.urlAfterRedirects);
      }
    });
  }

  ngOnInit() {

    this.home = { icon: 'pi pi-home', routerLink: 'common/user'};
    this.updateBreadcrumbs(this.router.url);

  }
  getdefaultRoute(){
        const userData = this.utitlityservice.getLoggeduser();
        
    if (userData?.defaultpagemircroservice) {
      
    return location.origin +userData.defaultpagemircroservice+"#/"
  }
  return ''
}

  private updateBreadcrumbs(url: string): void {
    const urlArray = url.split('/').filter(part => part);
    const inputArray = urlArray
    const outputArray = this.formatArray(inputArray);
    const breadcrumbs: MenuItem[] = [];
    const isDisabled = url.includes('common'); // condition for disbale the breadcrumbs

    let path = '';

    for (let i = 0; i < urlArray.length; i++) {
      path += `/${urlArray[i]}`;      
      breadcrumbs.push({
        label: outputArray[i],
        // title:this.titleService.getTitle(),
          routerLink: isDisabled ? undefined : path,
  styleClass: isDisabled ? 'disabled-breadcrumb' : ''
      });
    }   
    this.setBreadcrumbs(breadcrumbs);
  }

  private setBreadcrumbs(breadcrumbs: MenuItem[]): void {    
    this.routernames = [...breadcrumbs]; 
    
  }

  private formatArray(inputArray: string[]): string[] {
    return inputArray.map(item => 
      item
        .split('-') // Split each string by '-'
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(' ') // Join the words back with a space
    );
  }
  updatePageTitle(){
    this.router.events .pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activateroute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
    .subscribe((data) => {      
      if (data['title']) {
        this.titleService.setTitle(data['title']);
      }
    });
  }
 

}
